export const WHOLE_GERMANY_ID = 'WHOLE_GERMANY_ID'
